import { AdvancedMarker, useMap } from '@vis.gl/react-google-maps';
import { useCallback } from 'react';
import { imageUrl } from '@/vm/Shared/imageUrl';
import type { GeocodeLocation, VendingMachineLocation } from '~/contracts/vm';

const carvanaMapMarker = imageUrl('carvana_map_marker.png');

type LocationMarkerProps = {
  location: VendingMachineLocation;
  showMarkerLabels: boolean;
  setGeoCoords: (coords: GeocodeLocation & { label: string }) => void;
  updateActiveLocation: (location: Partial<VendingMachineLocation>) => void;
};

export default function LocationMarker({
  location,
  showMarkerLabels,
  setGeoCoords,
  updateActiveLocation
}: LocationMarkerProps) {
  const map = useMap();

  const handleMarkerClick = useCallback(
    (label: string, event: google.maps.MapMouseEvent) => {
      if (!map || !event.latLng) return;

      const newLocation = {
        lat: event.latLng.lat(),
        lng: event.latLng.lng(),
        label
      };

      setGeoCoords(newLocation);
      updateActiveLocation(newLocation);

      const z = map.getZoom() ?? 0;

      if (z > 4.7) {
        map.setZoom(4.7);
      }

      setTimeout(() => {
        map.panTo({ lat: newLocation.lat, lng: newLocation.lng });
        map.setZoom(8);
      }, 800);
    },
    [map, setGeoCoords, updateActiveLocation]
  );

  return (
    <>
      {/* eslint-disable-next-line local-rules/on-click-analytics-id, local-rules/on-click-testid */}
      <AdvancedMarker
        position={location}
        title={location.label || ''}
        onClick={e => handleMarkerClick(location.label, e)}
      >
        <div className="relative" data-testid="location-marker">
          <img alt="" src={carvanaMapMarker} width={34} height="auto" />
          {showMarkerLabels && (
            <span
              className="absolute left-full top-1/2 -translate-y-1/2 whitespace-nowrap text-lg font-medium leading-none"
              style={{
                textShadow:
                  '0 2px white, 0 -2px white, 2px 0 white, -2px 0 white'
              }}
            >
              {location.label}
            </span>
          )}
        </div>
      </AdvancedMarker>
    </>
  );
}
